import { useCallback, useEffect, useState } from "react";
import { CarrierServicesService } from "$services";
import { Activity, CarrierService } from "$types";
import useAuth from "./useAuth";

const useCarrierServiceItem = (carrierServiceId?: string) => {
  const { token } = useAuth();

  // Fetching
  const [carrierService, setCarrierService] = useState(null);
  const [isFetching, setIsFetching] = useState(false);
  const fetchCarrierService = useCallback(
    async (id: string) => {
      try {
        setIsFetching(true);
        const result = await CarrierServicesService.getCarrierService(
          token,
          carrierServiceId ?? id
        );
        setCarrierService(result);
      } catch (error: any) {
        console.error("Error fetching Carrier services:", error);
      } finally {
        setIsFetching(false);
      }
    },
    [setCarrierService, setIsFetching, carrierServiceId, token]
  );

  // Launch fetching
  useEffect(() => {
    setCarrierService(null);
    if (carrierServiceId) {
      fetchCarrierService(carrierServiceId);
    }
  }, [fetchCarrierService, setCarrierService, carrierServiceId]);

  const attachCompany = async (
    carrierServiceId: string,
    {
      companyId,
      carrierActivity,
    }: {
      companyId: CarrierService["companyId"];
      carrierActivity: Activity["name"];
    }
  ) => {
    await CarrierServicesService.updateCarrierService(token, carrierServiceId, {
      companyId,
      carrierActivity,
    });
  };

  const detachCompany = async (carrierServiceId: string) => {
    await CarrierServicesService.updateCarrierService(token, carrierServiceId, {
      companyId: null,
      carrierActivity: null,
    });
  };

  return {
    carrierService,
    isFetching,
    attachCompany,
    detachCompany,
  };
};

export default useCarrierServiceItem;
